'use strict';

angular.module('uniromaLandingApp')
.factory('AnagraficaService', ['$resource',function ($resource) {
	return {
		strutturati: $resource('api/strutturati', {}, {
			'get': { method: 'GET',
				params: {},
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
			
		}),
		anagrafiche: $resource('api/anagrafiche', {}, {
			'get': { method: 'GET',
				params: {},
				isArray: true,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			}
			
		}),
		strutturato: $resource('api/strutturato', {}, {
			'getOne': { method: 'GET',
				params: {},
				isArray: false,
				transformResponse: function (data) {
					data = angular.fromJson(data);
					return data;
				}
			},
			'update': { method: 'PUT',
				transformRequest: function (data) {
                  return angular.toJson(data);
              }
			}
			
		}),
		
		checkPersonalInformation: $resource('api/checkPersonalInformation', {}, {
			'check': { method: 'GET',
						params: {},
						isArray: false,
						transformResponse: function (data) {
							data = angular.fromJson(data);
							return data;
						}
			}
		}) /*,
		checkUniqueAlias: $resource('api/checkUniqueAlias', {}, {
			'check': { method: 'POST',
						params: {},
						isArray: false,
						transformResponse: function (data) {
							data = angular.fromJson(data);
							return data;
						}
			}
		})*/

	};
}]);
